/**
 * @param {number} numResults - number of search results
 * @returns {string} HTML container with the total number of search results
 */
export default numResults => `
    <div class="paging-info-count" data-products-count="${numResults}">
        <span>${numResults}</span>
        <span>${numResults === 1 ? window.Resources.SEARCH_RESULT_ITEM : window.Resources.SEARCH_RESULT_ITEMS}</span>
    </div>
`;
